import request from '@/utils/request'

export function getMenuList() {
  return request({ url: '/admin/menu/list', method: 'post' })
}

export function getMenuTree() {
  return request({ url: '/admin/menu/tree', method: 'post' })
}

export function createMenu(data) {
  return request({ url: '/admin/menu/create', method: 'post', data })
}

export function updateMenu(data) {
  return request({ url: '/admin/menu/update', method: 'post', data })
}

export function deleteMenu(data) {
  return request({ url: '/admin/menu/delete', method: 'post', data })
}

export function getUserMenus() {
  return request({ url: '/admin/menu/userMenus', method: 'post' })
}
